import { V404 } from '@/pages/errors'
import { RouteRecordRaw } from 'vue-router'

export const errorRoutes: Array<RouteRecordRaw> = [
  {
    path: '/404',
    name: '404',
    component: V404,
  },
]
